<ng-container *ngIf="searchClicked">
  <adc-loading
    label-text="Loading..."
    class="adc-loading"
    lock-page-scrolling="true"
    state="active"
  ></adc-loading>
</ng-container>

<div class="hdr ng-star-inserted" id="aa-content-frame" tabindex="-1">
  <section>
    <form
      [formGroup]="inputForm"
      #ngForm="ngForm"
      (ngSubmit)="submitForm(inputForm)"
    >
      <h1 class="font-bold !pl-0 text-[2.75rem] mobile:text-4xl bigTitle mb-[20px]">
        {{ pageData?.lookup?.heading }}
      </h1>

      <!-- Alert callout -->
      <div
        *ngIf="errorCount > 0"
        class="callout alert"
        role="alert"
        aria-labelledby="calloutHeadingAlert"
      >
        <div class="callout__heading">
          <h2 id="calloutHeadingAlert">
            {{ pageData?.lookup?.somethingWentWrong }}
          </h2>
        </div>
        <div class="callout__content">
          <p>
            {{ pageData?.lookup?.pleaseFix }}
            <span>{{ errorCount }} {{ pageData?.lookup?.errors }}</span
            >.
          </p>
        </div>
      </div>

      <div>
        <div class="grid grid-cols-4 mb-10">
          <div class="col-span-4">
            <div class="mt-2">
              <div class="grid grid-cols-4 gap-6">
                <!-- Ticket Number input field -->
                <div class="md:col-span-1 col-span-4">
              
                  <adc-text-input
                    formControlName="ticketNumber"
                    class="form-control"
                    id="HomePage_FormLastNameInputElement"
                    [name]="'ticketNumber'"
                    [attr.label-text]="pageData?.lookup?.ticketNumber"
                    required-validity-message=""
                    min-length="13"
                    (adc-clear)="revalidateForm('ticketNumber', $event)"
                    max-length="14"
                    [pattern]="ticketNumberPattern"
                    live-validation
                    a11y-live-error="polite"
                    required
                    ngDefaultControl
                  >
                  </adc-text-input>
                  <ng-container
                    *ngIf="
                      inputForm.get('ticketNumber').errors?.required &&
                      inputForm.get('ticketNumber')?.touched
                    "
                    ><div class="text-xs text-red-060">{{pageData?.lookup?.ticketNumberRequired}}</div
                  ></ng-container>
                </div>

                <!-- Last name input field -->
                <div class="md:col-span-1 col-span-4">
                  <adc-text-input
                    formControlName="lastName"
                    class="form-control"
                    id="HomePage_FormLastNameInputElement"
                    [name]="'lastname'"
                    [attr.label-text]="pageData?.lookup?.lastName"
                    required-validity-message=""
                    min-length="1"
                    (adc-clear)="revalidateForm('lastName', $event)"
                    max-length="20"
                    live-validation
                    a11y-live-error="polite"
                    required
                    ngDefaultControl
                  >
                  <!-- [pattern]="namePattern" -->

                  </adc-text-input>
                  <ng-container
                    *ngIf="
                      inputForm.get('lastName').errors?.required &&
                      inputForm.get('lastName')?.touched
                    "
                    ><div class="text-xs text-red-060">{{pageData?.lookup?.lastNameRequired}}</div
                  ></ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <a class="text-[#0078d2]"
            href="https://www.aa.com/i18n/customer-service/faqs/reservations-tickets-faqs.jsp#ticketnumber"
            target="_blank"
          >
            {{ pageData?.lookup?.findYourTicketNumber }}
            <span aria-hidden="true" class="icon-newpage"></span>
          </a>
        </div>
      </div>

      <hr class="divider--section" />
      <div class="grid-x grid-margin-x">
        <div class="cell large-3 large-order-2">
          <!-- <button
            [disabled]="searchClicked"
            ailPrimaryButton
            id="submitButton"
            class="expanded"
            type="submit"
            style="
              background-color: blue !important;
              text-align: end;
              color: white !important;
              padding: 5px !important;
            "
            aria-disabled="false"
          >
            {{ pageData?.lookup?.search }}
          </button> -->
          <adc-button class="px-[20px]  font-[400] " kind="primary" size="fullwidth"
          type="submit"
          kind="primary"
          [disabled]="searchClicked"
          id="submitButton"
          class="expanded"
          type="submit" > {{ pageData?.lookup?.search }}</adc-button>
        </div>
        <div class="cell large-3 large-offset-6 large-order-1"></div>
      </div>
    </form>
  </section>
</div>

<ng-container *ngIf="showRefundStatusErrorDialog">
  <adc-dialog id="tl-active-itin" class="adc-dialog" tabindex="-1" open="">
    <app-refund-status-error-dialog></app-refund-status-error-dialog>
  </adc-dialog>
</ng-container>
